import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type StarIconProps = { strokeColor?: string } & IconProps;

export const StarIcon: FC<StarIconProps> = ({
  iconColor = '#FEDF89',
  strokeColor = '#B54708',
  className,
  ...props
}) => (
  <svg
    className={twMerge('shrink-0', className)}
    {...props}
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.52193 1.30205C6.67559 0.990755 6.75242 0.835109 6.85672 0.78538C6.94746 0.742113 7.05289 0.742113 7.14363 0.78538C7.24793 0.835109 7.32476 0.990755 7.47842 1.30205L8.9362 4.25536C8.98157 4.34726 9.00425 4.39321 9.0374 4.42889C9.06674 4.46048 9.10194 4.48607 9.14104 4.50425C9.1852 4.52479 9.2359 4.5322 9.33731 4.54702L12.5982 5.02364C12.9415 5.07383 13.1132 5.09893 13.1927 5.1828C13.2618 5.25576 13.2943 5.35603 13.2812 5.45569C13.266 5.57022 13.1417 5.69129 12.8931 5.93342L10.5345 8.23078C10.4609 8.3024 10.4242 8.33821 10.4004 8.38081C10.3794 8.41854 10.366 8.45998 10.3608 8.50284C10.3549 8.55125 10.3636 8.60183 10.3809 8.703L10.9375 11.9479C10.9962 12.2902 11.0255 12.4613 10.9704 12.5628C10.9224 12.6512 10.8371 12.7132 10.7382 12.7315C10.6246 12.7526 10.4709 12.6717 10.1636 12.5101L7.24841 10.9771C7.15758 10.9293 7.11217 10.9054 7.06432 10.896C7.02196 10.8877 6.97839 10.8877 6.93602 10.896C6.88818 10.9054 6.84276 10.9293 6.75193 10.9771L3.83678 12.5101C3.52944 12.6717 3.37577 12.7526 3.26214 12.7315C3.16328 12.7132 3.07798 12.6512 3.02999 12.5628C2.97483 12.4613 3.00418 12.2902 3.06288 11.9479L3.61942 8.703C3.63677 8.60183 3.64545 8.55125 3.63958 8.50284C3.63438 8.45998 3.6209 8.41854 3.5999 8.38081C3.57618 8.33821 3.53941 8.3024 3.46589 8.23078L1.1072 5.93342C0.858605 5.69129 0.734306 5.57022 0.71918 5.45569C0.70602 5.35603 0.738532 5.25576 0.807663 5.1828C0.88712 5.09893 1.05881 5.07383 1.40219 5.02364L4.66304 4.54702C4.76445 4.5322 4.81515 4.52479 4.85931 4.50425C4.89841 4.48607 4.9336 4.46048 4.96295 4.42889C4.9961 4.39321 5.01878 4.34726 5.06415 4.25536L6.52193 1.30205Z"
      fill={iconColor}
      stroke={strokeColor}
      stroke-width="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
